module.exports = __webpack_public_path__ + "static/img/11.812b1a8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/11.png
// module id = wDn+
// module chunks = 0